"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveCartResponseMapper = void 0;
var SaveCartResponseMapper = /** @class */ (function () {
    function SaveCartResponseMapper(data) {
        this.localData = data;
    }
    SaveCartResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return SaveCartResponseMapper;
}());
exports.SaveCartResponseMapper = SaveCartResponseMapper;
//# sourceMappingURL=SaveCartResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/models/mappers/SaveCartResponseMapper.js
// module id = 1444
// module chunks = 8